import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DateRangePicker from "../../DateRangePicker/DateRangePicker";
import { ButtonGroup } from "@mui/material";
import _ from "lodash";
import dayjs, { Dayjs } from "dayjs";

// TODO this filter should instead be an object like { filterBy: "date" | "type"; dateRange?: { startDate: Dayjs; endDate: Dayjs }; type?: string }
// this is not a fast refactoring because the implementation carries across a handful of files

export type TimespanFilter =
  | string
  | {
      startDate: Dayjs;
      endDate: Dayjs;
    };
type CaseHistoryFilterProps = {
  filter: TimespanFilter;
  handleFilterChange: (filter: TimespanFilter) => void;
};
const CaseHistoryFilter = ({ filter, handleFilterChange }: CaseHistoryFilterProps) => {
  const [dateRangePickerOpen, setDateRangePickerOpen] = useState(false);

  const buttons = [
    {
      label: "Alles",
      filterName: "all",
    },
    {
      label: "Aktivität",
      filterName: "activity",
    },
    {
      label: "Notiz",
      filterName: "note",
    },
    {
      label: "E-Mail",
      filterName: "emailMessage",
    },
    {
      label: "Nachricht",
      filterName: "message",
    },
    {
      label: "Dokument",
      filterName: "mediaObject",
    },
    {
      label: "Änderung",
      filterName: "changes",
    },
    {
      label: "Aufgabe",
      filterName: "paidTask",
    },
    {
      label: "Anfrage",
      filterName: "inquiryToCustomer",
    },
  ];

  return (
    <Grid
      container
      sx={{
        justifyContent: "space-between",
      }}
    >
      <ButtonGroup color="primary">
        {_.map(buttons, (button) => (
          <Button
            key={button.filterName}
            variant={filter === button.filterName ? "contained" : "outlined"}
            onClick={() => handleFilterChange(button.filterName)}
          >
            {button.label}
          </Button>
        ))}
      </ButtonGroup>
      <Button
        sx={{
          width: "202px",
        }}
        variant={typeof filter === "object" ? "contained" : "text"}
        onClick={() => setDateRangePickerOpen(true)}
      >
        {typeof filter === "object"
          ? dayjs(filter.startDate).format("DD.MM.YY") + " - " + dayjs(filter.endDate).format("DD.MM.YY")
          : "Zeitraum auswählen"}
      </Button>
      <DateRangePicker
        setDateRange={handleFilterChange}
        open={dateRangePickerOpen}
        closeModal={() => setDateRangePickerOpen(false)}
      />
    </Grid>
  );
};

export default CaseHistoryFilter;
